// ============================================
// RESPOSTA HÁPTICA — vibração leve nos botões
// ============================================

const STORAGE_KEY = 'trucoxp:haptic';

const canVibrate = () => typeof navigator !== 'undefined' && 'vibrate' in navigator;

export const isHapticEnabled = () => {
  if (typeof window === 'undefined') return true;
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return stored === null ? true : stored === '1';
};

export const setHapticEnabled = (enabled) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0');
  window.dispatchEvent(new CustomEvent('trucoxp:haptic-change', { detail: enabled }));
};

const vibrate = (pattern) => {
  if (!canVibrate() || !isHapticEnabled()) return;
  navigator.vibrate(pattern);
};

// Leve — navegação, tabs, seleção (30ms)
export const hapticLight = () => vibrate(30);

// Média — botão de ação principal: jogar, depositar, sacar (50ms)
export const hapticMedium = () => vibrate(50);

// Forte — truco!, aceitar, fugir, jogar carta (70ms)
export const hapticHeavy = () => vibrate(70);

// Dupla — vitória, sucesso (dois pulsos)
export const hapticSuccess = () => vibrate([40, 30, 40]);

// Erro — falha, recusa
export const hapticError = () => vibrate([20, 10, 20, 10, 20]);
